<script>
export default {
  name: 'TwEmail',
  props: {
    modelValue: {
      type: [String,Number],
      default: null
    },
    label: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: () => Math.random().toString(36).substring(7)
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    prepend: {
      type: String,
      default: null
    }
  },
  emits: ['update:modelValue', 'update'],
}
</script>

<template>
  <div class="w-full">
    <label v-if="label" :for="id" class="form-label"> {{ label }} </label>
    <input :id="id" :disabled="disabled" :required="required" :value="modelValue" type="email" :name="id" :autocomplete="id" class="block w-full rounded-md border-0 py-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:ring-gray-400 placeholder:text-gray-400 focus:ring-1 focus:ring-inset text-sm focus:ring-gray-800  sm:leading-6" :placeholder="placeholder" @input="$emit('update:modelValue', $event.target.value)">
  </div>
</template>

<style scoped>

</style>
